import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";

export class Game extends Phaser.Game {

    public static currentInstance: Phaser.Game;

    constructor(config: Phaser.Types.Core.GameConfig) {
        
        super(config);
      
        Game.currentInstance = this;
        window.addEventListener('visibilitychange', () => {

            if (document.hidden) {
                AudioManager.onBlur();  
            } else {
                AudioManager.onFocus();
            }
        });
    }
}
